module.exports = __webpack_public_path__ + "static/img/ai_black.1c245212.png";